import React from "react"
import { Switch, Route } from "react-router-dom"
import BaseLayout from "src/layouts/Base"
import PlanType from "src/containers/PlanType"
import withRouteValidation from "src/hocs/withRouteValidation"
import {
  PLAN_TYPES_URL,
  PLAN_TYPES_ID_URL,
  DEFAULT_ID_VALIDATION_CONFIG,
} from "src/constants/routeNames"

export default (
  <Route path={PLAN_TYPES_URL}>
    <BaseLayout title="Типы планов">
      <Switch>
        <Route path={PLAN_TYPES_URL} exact component={PlanType} />
        <Route
          path={PLAN_TYPES_ID_URL}
          component={withRouteValidation({
            routeValidationConfig: DEFAULT_ID_VALIDATION_CONFIG,
          })(PlanType)}
        />
      </Switch>
    </BaseLayout>
  </Route>
)
